(function(){
'strict';

const $ = jQuery;

let btnConfirm        = $( '#btn-confirm-init-database' ),
	confirmationModal = $( '#modal-confirm-init-database' ),
	confirmationInput = confirmationModal.find( '.input-confirmation '),
	progressModal     = $( '#modal-progress-init-database' ),
	progressBar       = progressModal.find( '.progress-bar'),
	progressMessage   = progressModal.find( '.progress-message' ),
	eventSource       = null,
	callback          = null;

confirmationInput.on( 'input', function() {
	let val = $( this ).val().trim().toLowerCase();

	btnConfirm.attr( 'disabled', val != 'i agree' );
	if ( 'i agree' == val ) {
		btnConfirm.focus();
	}
});

btnConfirm.on( 'click', function() {
	confirmationModal.modal( 'hide' );
	progressModal.modal({
		backdrop: 'static',
		keyboard: false
	});

	callback();
});

function updateProgress( progress, message ) {
	progressBar.css( 'width', progress + '%' );
	progressMessage.text( message );
}

function resetData() {
}

Vue.component('initialize-database', {
	template: '#v-initialize-database',
	props: [],
	data: () => new resetData(),
	store,
	methods: {
		resetData,
		onShowTab() {
		},
		initializeDatabase(e) {
			e.preventDefault();

			callback = this.startTask;
			confirmationModal.modal();
			confirmationInput.focus();
		},
		startTask() {
			let eventSourceUrl;
			eventSourceUrl = ajax_object.ajax_url + '?action=initialize_database&session_id=' + encodeURIComponent(ajax_object.session_id);
			eventSource = new EventSource( eventSourceUrl );

			updateProgress( 0, 'Initializing Database' );

			//a message is received
			const _this = this;
			eventSource.addEventListener( 'message', function(e) {
				console.log(e);
				var result = JSON.parse( e.data );

				updateProgress( result.progress, result.message );

				if ( e.lastEventId == 'CLOSE') {
					eventSource.close();
					progressModal.modal( 'hide' );
					_this.$emit( 'completed', this )
				}

				if ( e.lastEventId == 'ERROR') {
					eventSource.close();
				}
			});

			eventSource.addEventListener('error', function(e) {
				console.log(e);
				updateProgress( 0, 'An error occurred: No additional information was provided by the server.' );
				eventSource.close();
			});
		},
	},
});
})();
